import { createSlice } from '@reduxjs/toolkit'
import {
  getLandingUrlDto,
  getLandingUrlState,
} from 'features/creative/creativeUtil'
import { validateLandingUrlWithSiteUrl } from 'features/creative/add/common/useCreativeValidation'

const initialState = {
  landingUrl: {
    individual: false,
    mobileUrl: '',
    pcUrl: '',
  },
}

export const validateCalculate = (active, { landingUrl }, siteUrl) => ({
  ...(active && validateLandingUrlWithSiteUrl(landingUrl, siteUrl)),
})

export const getCalculateAssetData = ({ landingUrl }) => ({
  type: 'CALCULATE',
  data: {
    landingUrl: getLandingUrlDto(landingUrl),
  },
})

const calulateSlice = createSlice({
  name: 'calculate',
  initialState,
  reducers: {
    reset: () => initialState,
    setIndividualChecked: (state, { payload: checked }) => {
      state.landingUrl.individual = checked
    },
    setMobileUrl: (state, { payload: mobileUrl }) => {
      state.landingUrl.mobileUrl = mobileUrl
    },
    setPcUrl: (state, { payload: pcUrl }) => {
      state.landingUrl.pcUrl = pcUrl
    },
    setCalculate: (state, { payload: { landingUrl } }) => {
      state.landingUrl = getLandingUrlState(landingUrl)
    },
  },
})

export const {
  reset,
  setPcUrl,
  setMobileUrl,
  setIndividualChecked,
  setCalculate,
} = calulateSlice.actions

export default calulateSlice.reducer
